import { Injectable } from '@angular/core';
import { Response, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ActHttpService } from '../act-http/act-http.service';
import { environment } from 'environments/environment';
import { ConfirmationSupplierVerifyTokenModel, ConfirmationSupplierEmailConfirmModel, ConfirmationSupplierEmailRejectModel } from '../../model/confirmationSupplier/confirmation-supplier-data';

@Injectable()
export class SupplierConfirmationService {

  constructor(
    private actHttpService: ActHttpService
  ) { }

  verifyConfirmationToken(data: ConfirmationSupplierVerifyTokenModel): Observable<Response> {
    const url = environment.endpoint.supplierConfirmation;
    return this.actHttpService.rawPost(url, data);
  }

  confirmationEmailConfirm( data: ConfirmationSupplierEmailConfirmModel): Observable<Response> {
    const url = environment.endpoint.supplierConfirmationSubmitEmailConfirm;
    return this.actHttpService.rawPost(url, data);
  }

  confirmationEmailReject( data: ConfirmationSupplierEmailRejectModel): Observable<Response> {
    const url = environment.endpoint.supplierConfirmationSubmitEmailReject;
    return this.actHttpService.rawPost(url, data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/confirmationSupplier/supplier-confirmation.service.ts